import type { FilterOption } from '@/components/FilterMenu'
import { FilterMenu } from '@/components/FilterMenu'
import { useTemplates } from '@/contexts/useTemplates'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface TemplateFilterProps {
  templatesData: { template_id: string; name?: string }[]
  selectedOption: FilterOption | null
  onChange: (option: FilterOption | null) => void
  renderMenuItem: <T>(option: FilterOption<T>, isSelected: boolean) => ReactNode
}

export function TemplateFilter({
  templatesData,
  selectedOption,
  onChange,
  renderMenuItem,
}: TemplateFilterProps) {
  const { t } = useTranslation()
  const { loadMoreTemplates } = useTemplates()

  const templateOptions = templatesData.map((data) => ({
    value: data.template_id,
    label: data.name ?? data.template_id,
  }))

  return (
    <FilterMenu
      buttonLabel={t('clusterConfigTable.filters.template')}
      options={templateOptions}
      selectedOption={selectedOption}
      onOptionChange={onChange}
      renderMenuItem={renderMenuItem}
      menuWidth={400}
      isSearchable
      searchFields="both"
      data-testid="template-filter"
      onMenuScrollToBottom={loadMoreTemplates}
    />
  )
}
